import Tastet from '../tastet.js';
import Template from '../modules/template.js';

var STATES = {
  AT_START: 'at-start',
  AT_END: 'at-end',
};

var CLASSES = {
  IS_SAFARI: 'is-safari',
};

export default class Slider extends Tastet.View {
  // init ------------------------------------------------------------------------------------------------------------
  init($el, data) {
    data = this.set(data || {}, {
      offset: [10, 10],
      move: '100v',
      duration: 300,
    });

    // this.$scroll = this.$scroll || this.$element;
    this.$list = this.$list || this.$scroll;
    this.template = new Template(this.$list);

    if (this._isSafari()) {
      this.$element.addClass(CLASSES.IS_SAFARI);
    }
  }

  addEvents() {
    this.on('scroll', this.list_onScroll);
    this.on(this.$previous, 'click', this.previous_onClick);
    this.on(this.$next, 'click', this.next_onClick);
  }

  render() {
    var scroll = this.$list.scroll();
    var isStart = scroll.x <= this.data.offset[0];
    var isEnd = scroll.x >= scroll.maxX - this.data.offset[1];

    this.state(STATES.AT_START, isStart);
    this.state(STATES.AT_END, isEnd);
  }

  refresh() {
    this.render();
  }

  // private  --------------------------------------------------------------------------------------------------------
  _isSafari() {
    if (typeof this._safari === 'bool') {
      return this._safari;
    }

    var match = null;
    var ua = navigator.userAgent;
    var isSafari = false;

    if (ua.match(/iP(ad|od|hone)/i) && (match = ua.match(/OS\s(\d+(?:\_\d+)?)/))) {
      isSafari = true;
      //Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.0.2 Safari/605.1.15
    } else if (~ua.indexOf('Safari') && (match = ua.match(/Version\/(\d+(?:\.\d+)?)/))) {
      isSafari = true;
    }

    this._safari = isSafari;

    return isSafari;
  }

  _move(page) {
    page = page || 1;

    var scroll = this.$list.scroll();
    var children = this.$list.children();
    var count = children.length;
    var style = this.$list.style();
    var gap = parseFloat(style.gap) || 0;
    var left = parseFloat(style.paddingLeft) || 0;
    var right = parseFloat(style.paddingRight) || 0;
    var dir = page ? 'next' : 'prev';

    children.each(true, function ($child) {
      var g = parseFloat($child.style('marginLeft')) || 0;
      gap = Math.max(gap, g);
    });

    var container = scroll.clientWidth;
    var content = scroll.width + gap - (left + right);
    var slide = content / count;
    var visible = ~~(container / slide) * slide || slide;

    var move = this.utils.calculate(this.data.move, {
      '%': container, // width of container
      v: visible, // width of fully visible slides
      s: slide, // width of a slide
    });

    // var x1 = scroll.x | 0;
    var x2 = scroll.x + move * page;
    x2 = Math.round(x2 / slide);
    x2 = x2 * slide;

    // center the element
    x2 = x2 - (container + gap - visible) / 2 + left;

    this.utils.dom.scrollTo(this.$list.get(0), {
      x: x2 | 0,
      duration: this.data.duration,
    });
  }

  // events ----------------------------------------------------------------------------------------------------------
  list_onScroll(e) {
    if (!this.$list.is(e.scrollTarget)) return;
    this.render();
  }

  previous_onClick(e) {
    e.preventDefault();
    this._move(-1);
  }

  next_onClick(e) {
    e.preventDefault();
    this._move(1);
  }

  // methods ---------------------------------------------------------------------------------------------------------
  add(item, refresh) {
    var $el = null;

    if (this.utils.is.el(item, true)) {
      $el = item;
      !this.$list.contains($el) && $el.appendTo(this.$list);
    } else if (this.utils.is.str(item)) {
      $el = this.$(item).appendTo(this.$list);
      this.scan($el);
    } else {
      var html = this.template.html(item);
      $el = this.$(html).appendTo(this.$list);
      this.scan($el);
    }

    if (refresh !== false) {
      this.refresh();
    }

    return $el;
  }
}
